import { Component, OnInit } from '@angular/core';
import { getLongDate, getStringDate } from 'src/app/common/util';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { BalanceResponse } from 'src/app/models/balanceresponse.model';
import { UserSaved } from 'src/app/models/user.model';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { CompanyService } from 'src/app/services/company.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CompanyRoleResponse } from 'src/app/models/company.model';
import { HttpErrorResponse } from '@angular/common/http';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import { forkJoin } from 'rxjs';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-results-information',
  templateUrl: './results-information.component.html',
  styleUrls: ['./results-information.component.scss']
})
export class ResultsInformationComponent implements OnInit {
  balances: { [companyId: string]: any } = {};
  endDate: string = "";
  companyInfos: { [companyId: string]: { nitCompany: string, nameCompany: string } } = {};
  user: UserSaved = null;
  companies = [];
  allCompanies = [];
  inputCompany = new InputAutocompleteModel("", false, false, "", "", "", "", [], []);
  selected = null;
  timeout = null;
  pagination = new PaginationModel(0, 5, 0, 0, [], []);
  buttonSave = new ButtonLoading("btn-success", false, "BUSCAR", "fa-search");
  sortedBalances: any[] = [];
  sortColumn: string = '';
  sortDirection: string = 'asc';
  sought = false;

  inputPartner = new InputAutocompleteModel("", false, false, "", "", "", "", [], []);
  selectedPartner = null;
  partners = [];
  allPartners = [];
  filterPartner = "";
  timeoutPartner = null;
  showPartnerFilter = false;
  columns = 
  [
    {name: "Venta de Bienes", displayId: "411", minimized: false },
    {name: "Prestación de Servicios", displayId: "412", minimized: false },
    {name: "Otros Ingresos", displayId: "413", minimized: false },
    {name: "Total Ingresos", displayId: "haber", minimized: false },
    {name: "Costo de Ventas", displayId: "511", minimized: false },
    {name: "Gastos Patronales", displayId: "521", minimized: false },
    {name: "Arrendamientos Operativos, Seguros, Reparaciones y Mantenimiento", displayId: "522", minimized: false },
    {name: "Depreciaciones, Cuentas Incobrables, Amortizaciones", displayId: "523", minimized: false },
    {name: "Honorarios Profesionales, Servicios Técnicos, Comisiones y Otros", displayId: "524", minimized: false },
    {name: "Gastos de Promoción, Viáticos, Transporte y Otros", displayId: "525", minimized: false },
    {name: "Gastos Financieros", displayId: "526", minimized: false },
    {name: "Impuestos, Contribuciones y Multas", displayId: "527", minimized: false },
    {name: "Gastos Generales", displayId: "528", minimized: false },
    {name: "Otros Gastos", displayId: "529", minimized: false },
    {name: "Total Otros Gastos", displayId: "debe", minimized: false },
    {name: "Utilidad", displayId: "utilidad", minimized: false }
  ]

  constructor(private accountingReport: AccountingReportService,
    private authService: AuthenticationService,
    private companyService: CompanyService,
    private toastService: ToastrService,
    private userService: UserService) { }
  

  ngOnInit(): void {
    const today = new Date();
    this.endDate = getStringDate(today);
    today.setDate(today.getDate() - 30);
    this.user = JSON.parse(this.authService.getCurrentUser());
    this.companies = Object.assign(this.companies, this.user.companyRoles);
    this.allCompanies = this.companies;
    this.partners = [...this.partners]
    this.allPartners = [...this.partners]
    if (this.user.contadorGT || this.user.userPartner) {
      this.showPartnerFilter = false;
      this.getAssociatedCompanies(this.user.id);
    }
    if(!this.user.contadorGT && !this.user.userPartner){
      this.showPartnerFilter = true;
      this.getPartners();
    }
  }

  
  minimize(col, isMinimize = true){
    col.minimized = isMinimize;
  }

  cropName(name: string) {
    let forCrop = name;
    if (forCrop) {
      var cropped = forCrop.slice(0, 40);
      return cropped + (name.length > 40 ? '...' : '');
    } else {
      return "";
    }
  }

  getAllBalances(): void {
    this.balances = {};
    this.companyInfos = {};
    var companyId = this.selected ? (this.selected.companyId ? this.selected.companyId: this.selected.id) : null;
    this.buttonSave.loading = true;
    if(companyId){
      this.getResultsAdminBook(companyId).subscribe({
        next: (response: BalanceResponse) => {
        if (response.success) {
          this.balances[companyId] = {
            totalDebe: response.data.totalDebe,
            totalHaber: response.data.totalHaber,
            accounts: response.data.accounts
          };
          this.companyInfos[companyId] = {
            nitCompany: response.data.nitCompany,
            nameCompany: response.data.nameCompany
          };
          this.sortedBalances = Object.keys(this.balances).map(companyId => {
            return { companyId, ...this.balances[companyId] };
          });
          this.pagination.total = this.getCompanyIds();
          this.resetPagination(this.pagination);
        }
        },error: (error: HttpErrorResponse) => {
          //console.error("Error en la solicitud o fallo del servidor.");
          this.sought = true;
          this.buttonSave.loading = false;
        },complete: () => {
          this.sought = true;
          this.buttonSave.loading = false;
        }
      }
    );
    }else{
      const requests = this.companies.map(company => 
        this.getResultsAdminBook((company.companyId? company.companyId : company.id)).pipe(
          tap((response: BalanceResponse) => {
            if (response.success) {
              this.balances[(company.companyId? company.companyId : company.id)] = {
                totalDebe: response.data.totalDebe,
                totalHaber: response.data.totalHaber,
                accounts: response.data.accounts
              };
              this.companyInfos[(company.companyId? company.companyId : company.id)] = {
                nitCompany: response.data.nitCompany,
                nameCompany: response.data.nameCompany
              };
              this.sortedBalances = Object.keys(this.balances).map(companyId => {
                return { companyId, ...this.balances[companyId] };
              });
              this.pagination.total = this.getCompanyIds();
              this.resetPagination(this.pagination);
            }
          }),
          catchError((error: HttpErrorResponse) => {
            return of(null);
          })
        )
      );
      
      forkJoin(requests).subscribe({
        next: () => {
          this.sought = true;
          this.buttonSave.loading = false;
        },
        complete: () => {
          this.sought = true;
          this.buttonSave.loading = false;
        }
      });
    }
  }

  filter(){
    if(this.endDate){
      this.getAllBalances();
    }
  }

  getAssociatedCompanies(idPartner:number) {
    this.companyService.getCompaniesAssociatedToPartner(idPartner).subscribe({
      next: (response: ResponseObject) => {
        this.companies = response.data;
        this.allCompanies = this.companies;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las companias asociadas");
      }
    })
  }


  getResultsAdminBook(companyId: any) {
    return this.accountingReport.getResultsAdminBook(getLongDate(this.endDate), companyId);
  }

  getBalanceById(companyId: string, displayId: string): number {
    const balanceData = this.balances[companyId];
    if (balanceData) {
      for (const account of balanceData.accounts) {
        if (account.displayId === displayId) {
          return account.balance;
        }
      }
    }
    return 0;
  }

  getCompanyIds(): string[] {
    return this.sortedBalances.map(balance => balance.companyId);
  }


  selectCompany(selected: any) {
    clearTimeout(this.timeout);
    this.inputCompany.value = selected.alphanumericId + " - " + (selected.companyNIT || selected.nit)  + " - " + (selected.companyName || selected.name);
    this.inputCompany.verified = true;
    this.inputCompany.class = "fa-circle-check";
    this.selected = selected;
    //this.filter();
  }

  searchCompany() {
    clearTimeout(this.timeout);
    this.inputCompany.class = "typing";
    this.selected = null;
    this.timeout = setTimeout(() => {
      this.companies = this.allCompanies.filter((company) => {
        var val = this.inputCompany.value.toLowerCase();
        return company.alphanumericId.toLowerCase() == val || company.companyName?.toLowerCase().includes(val) || company.companyNIT?.toLowerCase().includes(val)
        || company.name?.toLowerCase().includes(val) || company.nit?.toLowerCase().includes(val);
      });
      this.inputCompany.verified = false;
      if (this.companies.length > 0) {
        this.inputCompany.class = "fa-list";
      } else {
        this.inputCompany.class = "fa-xmark";
      }
      if (!this.inputCompany.value.toLowerCase()) {
        this.selected = null;
        //this.filter();
      }
    }, 300);
  }

  resetPagination(paginationTemp) { 
    paginationTemp.startElement = 0;
    paginationTemp.pageIndex = 0;
    paginationTemp.lastElement = paginationTemp.pageSize;
    paginationTemp.filter = paginationTemp.total.slice(paginationTemp.startElement, paginationTemp.lastElement);
    paginationTemp.lastElement = paginationTemp.filter.length;
  }

  sort(displayId: string) {
    if (this.sortColumn === displayId) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortDirection = 'asc';
    }
    this.sortColumn = displayId;
  
    this.sortedBalances.sort((a, b) => {

      const accountA = a.accounts.find(account => account.displayId === displayId);
      const accountB = b.accounts.find(account => account.displayId === displayId);

      const balanceA = accountA ? accountA.balance : 0;
      const balanceB = accountB ? accountB.balance : 0;

      if (balanceA < balanceB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (balanceA > balanceB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.sortCompanyInfosByBalances();
  }

  sortTotals(name: string) {
    if (this.sortColumn === name) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortDirection = 'asc';
    }
    this.sortColumn = name;
  
    this.sortedBalances.sort((a, b) => {
      let totalA = 0;
      let totalB = 0;
      if(name.match("haber")){
        totalA = a.totalHaber;
        totalB = b.totalHaber;
      }else if(name.match("debe")){
        totalA = a.totalDebe;
        totalB = b.totalDebe;
      }else if(name.match("utilidad")){
        totalA = a.totalHaber - a.totalDebe;
        totalB = b.totalHaber - b.totalDebe;
      }

      if (totalA < totalB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (totalA > totalB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.sortCompanyInfosByBalances();
  }

  sortCompanyInfosByBalances() {
    const sortedCompanyInfos: any[] = [];

    this.sortedBalances.forEach((balance) => {
      const companyId = balance.companyId;
  
      if (this.companyInfos[companyId]) {
        sortedCompanyInfos.push({
          companyId: companyId,
          ...this.companyInfos[companyId]
        });
      }
    });

    this.pagination.total = this.getCompanyIds();
    this.resetPagination(this.pagination);
  }

  
  getPartners() {
    this.userService.getPartnersWithoutSizeAndPageAndFilter()
      .subscribe({
        next: (response: ResponseObject) => {
          this.partners = response.data.partners;
          this.allPartners = this.partners;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      });
  }

  selectPartner(selected: any) {
    clearTimeout(this.timeoutPartner);
    this.inputPartner.value = selected.name +'-' + selected.email;
    this.inputPartner.verified = true;
    this.inputPartner.class = "fa-circle-check";
    this.selectedPartner = selected;
    this.getAssociatedCompanies(selected.id);
  }
  
  searchPartner(){
    clearTimeout(this.timeoutPartner);
    this.inputPartner.class = "typing";
    this.selectedPartner = null;
    this.timeoutPartner = setTimeout(() => {
      this.partners = this.allPartners.filter((partner) => {
        var val = this.inputPartner.value.toLowerCase();
        return partner.id == val || partner.email?.toLowerCase().includes(val) || partner.name?.toLowerCase().includes(val);
      });
      this.inputPartner.verified = false;
      if (this.partners.length > 0) {
        this.inputPartner.class = "fa-list";
      } else {
        this.inputPartner.class = "fa-xmark";
      }
      if (!this.inputPartner.value.toLowerCase()) {
        if(!this.user.contadorGT && !this.user.userPartner){
          this.companies = Object.assign(this.companies, this.user.companyRoles);
          this.allCompanies = this.companies;
        }else if(this.user.contadorGT || this.user.userPartner){
          this.getAssociatedCompanies(this.user.id);
        }
        this.selectedPartner = null;
      }
      
    }, 300);
  }
}
